exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".point-num[data-v-bdfdfbce]{font-size:1.8rem}", ""]);

// exports
